import axios from '@/libs/api.request'
var qs = require('qs');
// 获取列表数据
export const fetchTableList = (params) => {
    let data = params
    data = qs.stringify(data)
    return axios.request({
        url: '/virtual/list',
        data,
        method: 'post'
    })
};

// 新增
export const setAdd = (params) => {
    let data = params;
    data = qs.stringify(data);
    return axios.request({
        url: '/virtual/append',
        data,
        method: 'post'
    })
};
// 修改
export const setModify = (params) => {
    let data = params;
    data = qs.stringify(data);
    return axios.request({
        url: '/virtual/update',
        data,
        method: 'post'
    })
};

// 获取详情
export const fetchInfo = (params) => {
    let data = params;
    data = qs.stringify(data);
    return axios.request({
        url: '/virtual/info',
        data,
        method: 'post'
    })
};